import React, { useCallback, useContext, useMemo } from "react";
import { Button, Icon, Modal } from "antd";
import styles from "./index.module.scss";
import { CheckRounded } from "../CustomIcons";
import Spacer from "components/Spacer";
import CoursewareContext from "../../store";
import { CoursewareListItem, CourseWareTypeList } from "API/courseware";
import useRequestFn from "Utils/useRequestFn";
import { errorMessage } from "Utils/useRequest";
import { isTrue } from "Utils/filter";
import EditAksModal from "../../../../../../AskTeacher/Components/EditAksModal";
import lodash from "lodash-es";
import useModalHandler from "Utils/v3/useModalHandler";

interface FooterProps {
    onShowAside?: () => void;
}

export default function Footer({ onShowAside }: FooterProps) {
    const { current, list, onSelect, downloadCourseware, markDone } =
        useContext(CoursewareContext);

    const courseware = useMemo<CoursewareListItem | undefined>(() => {
        return list.find(item => item.id === current);
    }, [current, list]);

    const onNext = useCallback(() => {
        const currentIndex = list.findIndex(item => item.id === current);
        if (currentIndex === list.length - 1 || currentIndex === -1) return;

        const next = list[currentIndex + 1];
        onSelect(next.id);
    }, [current, list, onSelect]);

    const onPrev = useCallback(() => {
        const currentIndex = list.findIndex(item => item.id === current);
        if (currentIndex === 0 || currentIndex === -1) return;

        const next = list[currentIndex - 1];
        onSelect(next.id);
    }, [current, list, onSelect]);

    const [onMark, { loading }] = useRequestFn(async () => {
        if (!current) return;
        try {
            await markDone(current);
        } catch (e) {
            Modal.error(errorMessage(e));
        }
    });

    type keyType = keyof typeof CourseWareTypeList;
    const fileType = useMemo((): string => {
        const data = list[list.findIndex(item => item.id === current)];
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    data?.sourceFileEntity?.fileType?.toLowerCase() || ""
                )
            ) {
                return type;
            }
        }
        return "";
    }, [current]);

    const editModal = useModalHandler({
        component: EditAksModal
    });

    function openModal() {
        const data = lodash.find(list, { id: current });
        if (data) {
            console.log(data);

            const {
                batchNo,
                courseNo,
                courseName,
                courseSeq,
                customerCode,
                sourceFileEntity
            } = data;

            editModal.open({
                batchNo: batchNo!,
                courseNo: courseNo!,
                courseName: courseName!,
                courseSeq: courseSeq!,
                customerCode: customerCode!,
                viewUrl: sourceFileEntity?.viewUrl,
                fileName: sourceFileEntity?.fileName,
                onSuccess: editModal.close
            });
        }
    }

    return (
        <div className={styles.root}>
            <Button className={styles.btnPrev} onClick={onPrev}>
                <Icon type="caret-left" /> 上一个
            </Button>

            {/*//todo 暂时隐藏视频类型下载*/}
            {isTrue(courseware?.isDownload) && fileType !== "video" && (
                <Button
                    className={styles.btnDownload}
                    onClick={() => downloadCourseware(current || "")}>
                    <Icon type="download" />
                    下载课件
                </Button>
            )}

            <Button className={styles.btnAsk} onClick={openModal}>
                <Icon type="question-circle" />
                我要提问
            </Button>

            {!isTrue(courseware?.studyStatusEntity?.studyStatus) && (
                <Button
                    className={styles.btnMark}
                    onClick={onMark}
                    loading={loading}>
                    <Icon component={CheckRounded} /> 标记我已学
                </Button>
            )}

            <Spacer />

            <Button className={styles.listBtn} onClick={onShowAside}>
                课件列表
            </Button>

            <Button className={styles.btnNext} onClick={onNext}>
                下一个 <Icon type="caret-right" />
            </Button>

            {editModal.render()}
        </div>
    );
}
